import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLvtStream extends SnModel {
  @Expose()
  public refreshInterval: number;

  @Expose()
  public signalUrl: number;

  @Expose()
  public streamId: string;

  @Expose()
  public tokenType: { applicationName: string; streamName: string };

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
